import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import { RenderField } from '@oms/ui-field';
import { Checkbox, CheckboxGroup } from '@oms/ui-checkbox';

class InfoSelect extends React.Component {
  static propTypes = {
    additions: PropTypes.object.isRequired,
    addAddition: PropTypes.func.isRequired,
    removeAddition: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool,
  };

  handleToggle = (event) => {
    const { addAddition, removeAddition } = this.props;
    const { checked, value } = event.target;

    if (checked) {
      addAddition(value);
    } else {
      removeAddition(value);
    }
  };

  render() {
    const { additions, isLoggedIn } = this.props;
    const options = Object.entries(additions)
      .filter(([_id, item]) => !!item) // Filter out falsy values
      .filter(([_id, item]) => {
        if (item.requireLogin && !isLoggedIn) {
          return false;
        }
        return true;
      })
      .map(([id, item]) => ({
        value: id,
        label: item.name,
        checked: item.active,
      }));

    return (
      <CheckboxGroup
        name="checkbox"
        legend={<Trans>Information on the chart</Trans>}
      >
        {options.map((checkbox) => {
          return (
            <RenderField
              key={checkbox.label}
              as={Checkbox}
              name="checkbox"
              label={checkbox.label}
              value={checkbox.value}
              checked={checkbox.checked}
              onChange={this.handleToggle}
            />
          );
        })}
      </CheckboxGroup>
    );
  }
}

export default InfoSelect;
